<template>
  <div style="padding-right:25px;">
    <b-card>
      <b-form-group>
        <center>
          <h3 id="doc_caution_title">주의</h3>
        </center>
        <hr>
        <p class="doc_caution_content">이 보고서는 이용자의 자산 정보가 기밀로 되어 있습니다.</p>
        <p class="doc_caution_content">보고서 관리는 다음 참고 사항을 참조하십시오.</p>
        <p class="doc_caution_content">1. 유출을 금지한다.</p>
        <p class="doc_caution_content">2. 허가 없이 재가공하여 사용할 수 없습니다.</p>
        <p class="doc_caution_content">3. 보안요원 및 관련 권한 없는 자의 열람을 금지합니다.</p>
        <!-- <p class="doc_caution_content"></p> -->
      </b-form-group>
    </b-card>
  </div>
</template>

<script>
export default {
  name: "caution",
  data: () => {
    return {};
  },
  created: function() {
    console.log("[F1-UWSS]Caution.vue", "created");
  },
  destroyed: function() {
    console.log("[F1-UWSS]Caution.vue", "destroyed");
  },
  mounted: function() {
    console.log("[F1-UWSS]Caution.vue", "mounted");
  }
};
</script>
